module.exports = __webpack_public_path__ + "img/upload-2nd-present.da4562d7.png";